import { Accordion, Box, Text } from "@mantine/core";
import useStyles from "./styles";
import { IconInfoCircle } from "@tabler/icons-react";
import { IconChevronDown } from "@tabler/icons-react";

const ViewInfo = ({ data, labels }) => {
  const { classes } = useStyles();

  return data?.details ? (
    <Accordion
      variant="separated"
      radius="lg"
      className={classes.cpinfo}
      chevron={<IconChevronDown size={18} className={classes.cpinfoChevron} />}
      chevronPosition="right"
    >
      <Accordion.Item key={1} value={"Medication Detail"}>
        <Accordion.Control className={classes.cpinfoHead}>
          <Box className={classes.cpinfoHeadRow}>
            <Box className={classes.cpinfoBadge}>
              <IconInfoCircle size={16} />
            </Box>
            <Box className={classes.cpinfoHtext}>
              <Text className={classes.cpinfoEyebrow}>Care plan reference</Text>
              {/* Outcome Title is optional on a care plan — fall back to the
                  outcome's number so this never renders as a blank heading. */}
              <Text className={classes.cpinfoTitle}>
                {data?.details?.outcomeTitle ||
                  `${labels?.addNewButtonLabel || "Outcome"} ${
                    data?.details?.outcomeNumber ?? ""
                  }`.trim()}
              </Text>
            </Box>
          </Box>
        </Accordion.Control>
        <Accordion.Panel>
          <Box className={classes.cpinfoBody}>
            {data?.details?.activities?.map((a, index) => (
              <Box key={index} className={classes.cpinfoGrid}>
                <Box className={classes.cpinfoGridLeft}>
                  <Text className={classes.cpinfoLbl}>
                    {a?.activityNumber ? `${a.activityNumber}. ` : ""}
                    {labels?.supportActivityLabel || "Activity"}
                  </Text>
                  <Text className={classes.cpinfoVal}>
                    {a?.supportActivity || "-"}
                  </Text>
                </Box>
                <Box className={classes.cpinfoGridRight}>
                  <Text className={classes.cpinfoLbl}>
                    {labels?.supportInstructionsLabel || "Instructions"}
                  </Text>
                  {typeof a?.supportInstructions === "string" ? (
                    <Text className={classes.cpinfoVal}>
                      {a?.supportInstructions || "-"}
                    </Text>
                  ) : (
                    a?.supportInstructions?.map(({ text, id }) => (
                      <Text key={id} className={classes.cpinfoVal}>
                        {text || "-"}
                      </Text>
                    ))
                  )}
                </Box>
              </Box>
            ))}

            {data?.details?.additionalInformation && (
              <Box className={classes.cpinfoGrid}>
                <Box className={classes.cpinfoGridLeft}>
                  <Text className={classes.cpinfoLbl}>Additional Note</Text>
                  <Text className={classes.cpinfoVal}>
                    {data?.details?.additionalInformation || "-"}
                  </Text>
                </Box>
              </Box>
            )}

            <Box className={classes.cpinfoFoot}>
              <Text
                className={`${classes.cpinfoLbl} ${classes.cpinfoFootLbl}`}
              >
                How Often
              </Text>
              <Box className={classes.cpinfoPill}>
                {data?.details?.howOften || "-"}
              </Box>
            </Box>
          </Box>
        </Accordion.Panel>
      </Accordion.Item>
    </Accordion>
  ) : (
    <></>
  );
};
export default ViewInfo;
